import React from 'react';
import ComboSection from './ComboSection';
import PriceSection from './PriceSection';
import ReplacementSection from './ReplacementSection';

/**
 * Generic experiment section wrapper
 * Renders appropriate section based on experiment type
 */
const ExperimentSection = (props) => {
  const { experiment } = props;
  
  // Determine experiment type and render appropriate component
  if (experiment?.experimentType === 'promo_precio_unitario' || experiment?.experimentType === 'alza_precio_sugerido') {
    return <PriceSection {...props} />;
  }
  
  if (experiment?.experimentType === 'reemplazo_producto' || experiment?.experimentType === 'ampliar_carril') {
    return <ReplacementSection {...props} />;
  }
  
  // Default to combo section for 'promo_combo_combinado' or undefined types
  return <ComboSection {...props} />;
};

export default ExperimentSection;